import { useMemo } from "react";
import { cashnatorFloat } from "../utils/functions";
import SimpleTable from "../table/SimpleTable";

const KIND_LABELS = { percent: "Percentual", amount: "Quantia" };

const CouponsList = ({ coupons, setEdit, setEditableCoupon }) => {
    const columns = useMemo(() => [
        { key: "code", header: "Código", width: 120 },
        { key: "value", header: "Valor", width: 110, format: (value, row) => (row?.kind === "amount" ? cashnatorFloat(value) : `${value}%`) },
        { key: "kind", header: "Tipo", width: 110, labels: KIND_LABELS },
        {
            key: "isActive", header: "Ativo", width: 90, format: (value) => (value ? "✔" : "X"),
            cellClassName: (row) => (row.isActive ? "text-green-500" : "text-red-500"),
        },
        { key: "timesUsed", header: "Utilizações", width: 110 },
        {
            key: "ver", header: "", width: 70, sortable: false, hideable: false, exportable: false,
            cell: ({ row }) => <button type="button" onClick={() => { setEdit(true); setEditableCoupon(row); }} className="bg-blue-500 px-2 text-black hover:bg-blue-800">Ver</button>,
        },
    ], [setEdit, setEditableCoupon]);
    return <SimpleTable tableKey="admin-coupons" columns={columns} data={coupons} />;
};

export default CouponsList;
